import styled from "styled-components";

export const UnknowErrorImage = styled.img`
    margin: 15px 0;
    max-height: 250px;
`;